import React from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableContainer from '@material-ui/core/TableContainer'
import Paper from '@material-ui/core/Paper'

const useStyles = makeStyles(theme => createStyles({
  root: {
    width: '100%',
  },
  table: {
    
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  autoCell: {
    width: 'auto',
  },
}))

const SimpleTable = ({
  data,
  fields,
  getActions, 
  onRowClick,
  hideHeaderIfEmpty,
  hideHeader,
  actionsFieldClassname,
  compact,
  withContainer,
  actionsTitle = 'Actions',
}) => {
  const classes = useStyles({
    compact,
  })

  const table = (
    <Table className={classes.table} size={ compact ? 'small' : 'medium' }>
      {
        (!hideHeader && (!hideHeaderIfEmpty || data.length > 0)) && (
          <TableHead>
            <TableRow>
              {
                fields.map((field, i) => {
                  return (
                    <TableCell key={ i } align={ field.numeric ? 'right' : 'left' }>
                      { field.title }
                    </TableCell>
                  )
                })
              }
              {
                getActions ? (
                  <TableCell align='right'>
                    { actionsTitle }
                  </TableCell>
                ) : null
              }
            </TableRow>
          </TableHead>
        )
      }
      <TableBody>
        {data.map((dataRow, i) => {
          return (
            <TableRow
              hover
              onClick={e => {
                if(!onRowClick) return
                onRowClick(dataRow)
              }}
              tabIndex={-1}
              key={ i }
            >
              {
                fields.map((field, i) => {
                  return (
                    <TableCell 
                      key={ i } 
                      align={ field.numeric ? 'right' : 'left' } 
                      className={ field.className || classes.autoCell }
                      style={ field.style }
                    >
                      { dataRow[field.name] }
                    </TableCell>
                  )
                })
              }
              {
                getActions ? (
                  <TableCell align='right' className={ actionsFieldClassname }>
                    { getActions(dataRow) }
                  </TableCell>
                ) : null
              }
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  )

  const renderTable = withContainer ? (
    <TableContainer component={Paper}>
      { table }
    </TableContainer>
  ) : table
  
  return (
    <div className={classes.root}>
      <div className={classes.tableWrapper}>
        { renderTable }
      </div>
    </div>
  )
}

export default SimpleTable